/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryFlat } from '../../models/category-flat';

export interface ApiProductsqueryCategoriesHighlightedGet$Plain$Params {
}

export function apiProductsqueryCategoriesHighlightedGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProductsqueryCategoriesHighlightedGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryFlat>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryCategoriesHighlightedGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CategoryFlat>>;
    })
  );
}

apiProductsqueryCategoriesHighlightedGet$Plain.PATH = '/api/productsquery/categories/highlighted';
